// extracted by mini-css-extract-plugin
module.exports = {"title":"about_title__3t4bU","sub_title":"about_sub_title__1VtxT","margin":"about_margin__14OU0"};